import { GetUserDocument, GetUserEventsDocument } from '../../__generated__/graphql/api';

export const getUserRefetchQuery = (userId: string) => ({
  refetchQueries: [
    { query: GetUserDocument, variables: { userId } },
    { query: GetUserEventsDocument, variables: { userId } },
  ],
});
